import React from 'react';
import ReactPaginate from 'react-paginate';
import { Link } from 'gatsby-plugin-react-i18next';
import PropTypes from 'prop-types';
import useLanguage from '../../../../hooks/useLanguage';
import Star from '../../../../svg/star_non_shadow.svg';
import Arrow from '../../../../svg/arr_right_top.svg';
import ArrowLeft from '../../../../svg/arrow_left_2.svg';
import ArrowRight from '../../../../svg/arrow_right_2.svg';
import {fromArticleSlugToUrl} from '../../../../utils/slug' 


const BlogItems = ({ articlesData }) => {
  const langToggle = useLanguage;

  const blogList = articlesData;
  const [articles] = React.useState(blogList.slice(0, 1000));
  const [pageNumber, setPageNumber] = React.useState(0);

  const articlesPerPage = 8;
  const pagesVisited = pageNumber * articlesPerPage;

  const displayArticles = articles
    .slice(pagesVisited, pagesVisited + articlesPerPage)
    .map((item) => {
      return (
        <li className="blog__item" key={item.node.article.id}>
          <Link to={fromArticleSlugToUrl(item.node.slug)} className="blog__item-link">
            <span className="blog__number">
              <span>{item.node.article.id <= 9 ? '0' + item.node.article.id + '.' : item.node.article.id + '.'}</span>
            </span>
            <div className="blog__container">
              <span className="blog__category">
                {langToggle(item.node.category.title_ua, item.node.category.title_ru)}
              </span>
              <span className="blog__title">
                {langToggle(item.node.article.title_ua, item.node.article.title_ru)}
              </span>
              <div className="blog__subtitle">
                <span className="blog__time">
                  {langToggle(item.node.article.time_ua, item.node.article.time_ru)}
                </span>
                <span className="blog__slash">{' / '}</span>
                <span className="blog__date">{item.node.article.date}</span>
              </div>
            </div>
            <span className="blog__icon-wrapper">
              <span className="blog__icon">
                <Star className="blog__icon-star" />
                <Arrow className="blog__icon-arrow" />
              </span>
            </span>
          </Link>
        </li>
      );
    });
  const pageCount = Math.ceil(blogList.length / articlesPerPage);
  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  return (
    <div className="blog-items" data-scroll-section>
      <div className="content-wrapper">
        <ul className="blog__list">{displayArticles}</ul>
        <ReactPaginate
          previousLabel={<ArrowLeft />}
          nextLabel={<ArrowRight />}
          pageCount={pageCount}
          breakLabel={'...'}
          breakClassName={'pagination__break'}
          breakLinkClassName={'pagination__break-link'}
          onPageChange={changePage}
          containerClassName={'pagination'}
          pageClassName={'pagination__item'}
          pageLinkClassName={'pagination__link'}
          activeClassName={'pagination__item--active'}
          activeLinkClassName={'pagination__link--active'}
          previousClassName={'pagination__previous'}
          nextClassName={'pagination__next'}
          marginPagesDisplayed={1}
          pageRangeDisplayed={2}
        />
      </div>
    </div>
  );
};

BlogItems.propTypes = {
  itemsData: PropTypes.array,
};

export default BlogItems;
